import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../service/axiosInstance";

export const fetchPublishedArticles = createAsyncThunk(
  "articles/fetchPublished",
  async ({ page = 1 } = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("articles/", { params: { page } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchMyArticles = createAsyncThunk(
  "articles/fetchMy",
  async (_arg, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("articles/my/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchEditorQueue = createAsyncThunk(
  "articles/fetchQueue",
  async (_arg, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("articles/queue/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchArticleById = createAsyncThunk(
  "articles/fetchById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`articles/${id}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createArticle = createAsyncThunk(
  "articles/create",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("articles/", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateArticle = createAsyncThunk(
  "articles/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`articles/${id}/`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const submitArticle = createAsyncThunk(
  "articles/submit",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`articles/${id}/submit/`, {});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const cancelSubmission = createAsyncThunk(
  "articles/cancelSubmission",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`articles/${id}/cancel/`, {});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteArticle = createAsyncThunk(
  "articles/delete",
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`articles/${id}/`);
      return { id };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const publishArticle = createAsyncThunk(
  "articles/publish",
  async ({ id, section, priority }, { rejectWithValue }) => {
    try {
      const body = {};
      if (section && section !== "none") body.section = section;
      if (priority !== undefined && priority !== null) body.priority = priority;
      const response = await axiosInstance.post(`articles/${id}/publish/`, body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const rejectArticle = createAsyncThunk(
  "articles/reject",
  async ({ id, note }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`articles/${id}/reject/`, { note });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadArticleImage = createAsyncThunk(
  "articles/uploadImage",
  async ({ file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("image", file);
      const response = await axiosInstance.post("articles/upload-image/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data || error.message,
      });
    }
  }
);
